module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-2021-3.2cfc967b.jpg";